export enum nextStepPage {
  LANDING_PAGE = 'landing-page',
  ENTER_PHONE_NUMBER_PAGE = 'enter-phone-number',
  HELP_SIGNATURE_DRAW_PAD_PAGE = 'help-signature-draw-pad',
  SIGNATURE_DRAW_PAD_PAGE = 'signature-draw-pad',
  VERIFY_PHONE_NUMBER_PAGE = 'verify-phone-number',
  NATIONAL_CODE_PAGE = 'national-code',
  SHEBA_NUMBER_PAGE = 'sheba-number',
  LOCATION_INFORMATION_PAGE = 'location-information',
  COMPLETE_USER_INFO_PAGE = 'complete-user-info',
  COMPLETE_IDENTIFY_INFORMATION_PAGE = 'complete-identify-information',
  CONFIRM_INFORMATION_PAGE = 'confirm-info',
  SUCCESS_PAYMENT_PAGE = 'success-payment',
  FIELD_PAYMENT_PAGE = 'field-payment',
  UNPAID_PAGE = 'no-payment',
  INFORMATION_CONFIRMED_PAGE = 'information-confirmed',
  INFORMATION_WAITING_PAGE = 'information-waiting',
  NO_FACE_MATCHING_PAGE = 'no-face-matching',
  FACE_RECOGNITION_RECORDING_PAGE = 'face-recognition-recording',
  TAKE_PICTURE_NATIONAL_CARD_FRONT_PAGE = 'take-picture-national-card-front',
  TAKE_PICTURE_NATIONAL_CARD_BACK_PAGE = 'take-picture-national-card-back',
  TAKE_PICTURE_SIGNATURE_PAGE = 'take-picture-signature',
  VIDEO_CONFIRMED_PAGE = 'video-confirmed',
  OTP_PAGE = 'otp-page',
  USER_INFORMATION_PAGE = 'user-information',
  DIVAR_SUCCESS_PAYMENT_PAGE = 'divar-success-payment',
  BANK_CARD_NUMBER_PAGE = 'bank-card',
  SUCCESS_AUTHENTICATION_PAGE = 'success-authentication',
  SUCCESS_AUTHENTICATION_FLOW = 'success-authentication-flow',
  CAR_PLATE_NUMBER_PAGE = 'plate-number',
  CAR_INFO_PAGE = 'car-info',
  BIRTH_DATE_PAGE = 'birth-date',
  POSTAL_CODE_PAGE = 'postal-code',
  LICENSE_PERSONALITY_PAGE = 'license-personality-type',
  LICENSE_PERSONALITY_INFO_PAGE = 'license-personality-info',
  NATIONAL_CARD_SERIAL_PAGE = 'national-card-serial',
  GET_BASIC_INFO_PAGE = 'get-basic-info',
}
export enum nextStepTokenResponse {
  GENERAL = 0,
  REDIRECT_BUSINESS = 1,
}
